import type { ParsedUrlQuery } from 'querystring';

export const getPageFromParam = (query: ParsedUrlQuery) => {
  const { page } = query;
  const pageValue = Array.isArray(page) ? page[0] : page;
  const pageNumber = Number(pageValue);

  return Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : 1;
};
